import { useCallback } from 'react'
import { useBucket } from '@mc/experiments-react'
import { EventTypes, trackKeyGrowthEvent } from '@mc/track-event'

import { useCategoryInterests } from './useCategoryInterests'
import { useSubcategoryInterests } from './useSubcategoryInterests'
import { useCanGoStraightToQR } from './useCanGoStraightToQR'
import { trackStraightToQR, trackStraightToQRExperimentViewed } from '../events'
import { STRAIGHT_TO_QR_EXP_FLAG, getStraightToQRPath } from '../constants'

export const useStraightToQR = () => {
  const bucket = useBucket(STRAIGHT_TO_QR_EXP_FLAG)
  const isVariant = bucket?.includes('variant')

  const canGoStraightToQR = useCanGoStraightToQR()
  const subcatInterests = useSubcategoryInterests()
  const categoryInterests = useCategoryInterests()

  const href = getStraightToQRPath(categoryInterests, subcatInterests)

  const onClick = useCallback(() => {
    if (canGoStraightToQR && categoryInterests.length) {
      trackStraightToQRExperimentViewed()
      if (isVariant) {
        trackStraightToQR(categoryInterests, subcatInterests)
        trackKeyGrowthEvent(EventTypes.QUIZ_PAGE_VIEWED)
      }
    }
  }, [canGoStraightToQR, isVariant, categoryInterests, subcatInterests])

  if (!canGoStraightToQR || !categoryInterests.length) {
    return undefined
  }

  return {
    href: isVariant ? href : undefined,
    onClick,
  }
}
